import React from 'react';

const Check = ({ id, checked, onChange, required, children, testId }) => (
  <label htmlFor={id} className="flex items-start gap-3 cursor-pointer">
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-1 w-5 h-5 shrink-0 rounded border-zinc-600 bg-zinc-800 accent-[#C41E3A]"
      data-testid={testId}
    />
    <span className="text-sm text-zinc-300">
      {children}
      {required ? <span className="text-[#C41E3A]"> *</span> : <span className="text-zinc-500 text-xs"> (optional)</span>}
    </span>
  </label>
);

const link = (href, text) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#C41E3A] hover:underline font-medium">{text}</a>
);

export const consentsValid = (c) => c.terms_accepted && c.data_processing_accepted;

export const ConsentChecks = ({ value, onChange, prefix = 'consent' }) => (
  <div className="bg-zinc-900/50 border border-zinc-800 rounded-lg p-4 space-y-3" data-testid={`${prefix}-checks`}>
    <Check id={`${prefix}-terms`} required checked={value.terms_accepted} onChange={(v) => onChange({ ...value, terms_accepted: v })} testId={`${prefix}-terms`}>
      I have read and agree to the {link('/terms', 'Terms of Service')} and {link('/privacy', 'Privacy Policy')}
    </Check>
    <Check id={`${prefix}-data`} required checked={value.data_processing_accepted} onChange={(v) => onChange({ ...value, data_processing_accepted: v })} testId={`${prefix}-data-processing`}>
      I consent to BrandStage storing and processing my personal and company data to create and host my profile and videos, as described in the Privacy Policy (DPDP Act 2023 / GDPR). I can withdraw this consent anytime.
    </Check>
    <Check id={`${prefix}-marketing`} checked={value.marketing_consent} onChange={(v) => onChange({ ...value, marketing_consent: v })} testId={`${prefix}-marketing`}>
      Send me occasional updates, event invitations and offers from BrandStage
    </Check>
  </div>
);
